import { render, staticRenderFns } from "./PageSettingsTax.vue?vue&type=template&id=b22343dc&"
import script from "./PageSettingsTax.vue?vue&type=script&lang=js&"
export * from "./PageSettingsTax.vue?vue&type=script&lang=js&"
import style0 from "./PageSettingsTax.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports